'use strict';exports.__esModule = true;exports.trackGTM = exports.trackGTMPublishPackage = exports.trackEcommerce = exports.trackEvent = exports.setData = exports.trackModalOpen = exports.trackPage = exports.initAnalytics = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _google = require('./google');









var _constants = require('../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var initAnalytics = exports.initAnalytics = function initAnalytics() {
  switch (_constants.analytics.analyticsProvider) {
    case 'google':
      (0, _google.initGTM)();
      (0, _google.initGA)();
      break;
    default:
      console.warn('Not valid analytics provider');
      break;}

};

var trackPage = exports.trackPage = function trackPage(page) {
  switch (_constants.analytics.analyticsProvider) {
    case 'google':
      (0, _google.gaTrackPage)(page);
      break;
    default:
      console.warn('Not valid analytics provider');
      break;}

};

/**
    * @param {object} modalType
    */
var trackModalOpen = exports.trackModalOpen = function trackModalOpen(modalType) {
  switch (_constants.analytics.analyticsProvider) {
    case 'google':
      (0, _google.gaTrackModalOpen)(modalType);
      break;
    default:
      console.warn('Not valid analytics provider');
      break;}

};

/**
    * @param {object} data
    */
var setData = exports.setData = function setData(data) {
  switch (_constants.analytics.analyticsProvider) {
    case 'google':
      (0, _google.gaSetData)(data);
      break;
    default:
      console.warn('Not valid analytics provider');
      break;}

};

/**
    * @param {string} category
    * @param {string} action
    * @param {string} label
    */
var trackEvent = exports.trackEvent = function trackEvent(category, action, label) {
  var data = {
    category: category,
    action: action,
    label: label || null };

  switch (_constants.analytics.analyticsProvider) {
    case 'google':
      (0, _google.gaTrackEvent)(data);
      break;
    default:
      console.warn('Not valid analytics provider');
      break;}

};

/**
    * @param {string} id
    * @param {string} name
    * @param {string} price
    * @param {string} tax
    * @param {string} category
    * @param {string} quantity
    */
var trackEcommerce = exports.trackEcommerce = function trackEcommerce(id, name, price, tax, category, quantity) {
  switch (_constants.analytics.analyticsProvider) {
    case 'google':
      (0, _google.gaTrackEcommerce)(id, name, price, tax, category, quantity);
      break;
    default:
      console.warn('Not valid analytics provider');
      break;}

};

var regularUserPackagesData = {
  1: {
    name: 'USER-FREE',
    label: 'free' },

  2: {
    name: 'USER-PROMOTED',
    label: 'promoted' },

  3: {
    name: 'USER-PREMIUM',
    label: 'premium' } };



var buildRealtorEventLabel = function buildRealtorEventLabel(count, period) {
  var periodPart = +period === 12 ? '1YEAR' : '3MONTH';
  return count + 'ADS-' + periodPart;
};

var trackGTMPublishPackage = exports.trackGTMPublishPackage = function trackGTMPublishPackage(packageData, isAgent) {
  switch (_constants.analytics.analyticsProvider) {
    case 'google':{
        var action = isAgent ? 'realtor' : 'user';

        var label = isAgent ?
        buildRealtorEventLabel(packageData.properties, packageData.period) :
        (0, _get2.default)(regularUserPackagesData, '[' + packageData.id + '].label');

        var name = isAgent ? 'REALTOR-' +
        label :
        (0, _get2.default)(regularUserPackagesData, '[' + packageData.id + '].name');

        (0, _google.gtagSendEvent)({ name: name, category: 'Publish', action: action, label: label });
        break;
      }

    default:
      console.warn('Not valid analytics provider');
      break;}

};

var trackGTM = exports.trackGTM = function trackGTM(_ref) {var name = _ref.name,category = _ref.category,action = _ref.action,label = _ref.label,value = _ref.value,transactionId = _ref.transactionId,item = _ref.item;
  switch (_constants.analytics.analyticsProvider) {
    case 'google':{
        (0, _google.gtagSendEvent)({ name: name, category: category, action: action, label: label, value: value, transactionId: transactionId, item: item });
        break;
      }

    default:
      console.warn('Not valid analytics provider');
      break;}

};


//////////////////
// WEBPACK FOOTER
// ./src/utils/analytics/analyticsManager.js
// module id = 23
// module chunks = 0